import { render } from "./HistorialSeguimientoPage.vue?vue&type=template&id=3e7561c4"
import script from "./HistorialSeguimientoPage.vue?vue&type=script&lang=js"
export * from "./HistorialSeguimientoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__